import { getNotificationUrl } from '../../utils/base-url';
import { RefreshableHttpServiceConfigurator } from './refreshable-http-service-configurator';

export class NotificationHttpServiceConfigurator extends RefreshableHttpServiceConfigurator {

  getHttpClientConfig() {
    const baseConfig = super.getHttpClientConfig();
    return {
      ...baseConfig,
      baseURL: getNotificationUrl(),
    };
  }
}
